<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">ダッシュボード</a>
      </li>
      <li class="active">ゲート一覧</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace gateId" checked="checked" @click="addRomoveScorp('gateId', 'gateId')">
        <span class="lbl">ゲートID</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace gateModelName" checked="checked" @click="addRomoveScorp('gateModelName', 'gateModelName')">
        <span class="lbl">製品名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace gateName" checked="checked" @click="addRomoveScorp('gateName', 'gateName')">
        <span class="lbl">ゲート名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option1" checked="checked" @click="addRomoveScorp('option1', 'option1')">
        <span class="lbl">備考.1</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option2" checked="checked" @click="addRomoveScorp('option2', 'option2')">
        <span class="lbl">備考.2</span>
      </label>
    </div>
    <span class="input-icon search-box">
      <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
      <i class="ace-icon fa fa-search nav-search-icon"></i>
    </span>
    <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
    <button v-if="selectedGateId.length>0" class="btn-cusstom black-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたゲートを無効化</button>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content" style="padding-top:133px">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group view-option">
                  <span class="warring2">
                    一覧に表示できる項目は８項目までになります。
                  </span>
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateId" type="checkbox" class="ace" disabled checked>
                      <span class="lbl">ゲートID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateModelId" type="checkbox" @click="ShowHideColumn" class="ace" value="gateModelId" v-model="checkedColumnNames">
                      <span class="lbl">製品ID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateModelName" type="checkbox" @click="ShowHideColumn" class="ace" value="gateModelName" v-model="checkedColumnNames">
                      <span class="lbl">製品名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateModelCode" type="checkbox" @click="ShowHideColumn" class="ace" value="gateModelCode" v-model="checkedColumnNames">
                      <span class="lbl">型番</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="iconType" type="checkbox" @click="ShowHideColumn" class="ace" value="iconType" v-model="checkedColumnNames">
                      <span class="lbl">アイコンタイプ</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="makerCode" type="checkbox" @click="ShowHideColumn" class="ace" value="makerCode" v-model="checkedColumnNames">
                      <span class="lbl">メーカー番号</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="customizable" type="checkbox" @click="ShowHideColumn" class="ace" value="customizable" v-model="checkedColumnNames">
                      <span class="lbl">変更有無</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="target" type="checkbox" @click="ShowHideColumn" class="ace" value="target" v-model="checkedColumnNames">
                      <span class="lbl">ターゲット動作設定</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="controlTime" type="checkbox" @click="ShowHideColumn" class="ace" value="controlTime" v-model="checkedColumnNames">
                      <span class="lbl">ターゲット動作設定Time</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="timeUnit" type="checkbox" @click="ShowHideColumn" class="ace" value="timeUnit" v-model="checkedColumnNames">
                      <span class="lbl">ターゲット動作設定TimeUnit</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateName" type="checkbox" class="ace" @click="ShowHideColumn" value="gateName" v-model="checkedColumnNames">
                      <span class="lbl">ゲート名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="isVisitor" type="checkbox" class="ace" @click="ShowHideColumn" value="isVisitor" v-model="checkedColumnNames">
                      <span class="lbl">ゲート動作モード</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="isNFCValid" type="checkbox" class="ace" @click="ShowHideColumn" value="isNFCValid" v-model="checkedColumnNames">
                      <span class="lbl">NFCの有効</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="isTenKeyValid" type="checkbox" class="ace" @click="ShowHideColumn" value="isTenKeyValid" v-model="checkedColumnNames">
                      <span class="lbl">テンキーの有効・無効</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="isGatePasswordValid" type="checkbox" class="ace" @click="ShowHideColumn" value="isGatePasswordValid" v-model="checkedColumnNames">
                      <span class="lbl">ゲートパスワードの有効・無効</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gatePasswordLength" type="checkbox" class="ace" @click="ShowHideColumn" value="gatePasswordLength" v-model="checkedColumnNames">
                      <span class="lbl">ゲートパスワードの桁数</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gatePasswordSeed" type="checkbox" class="ace" @click="ShowHideColumn" value="gatePasswordSeed" v-model="checkedColumnNames">
                      <span class="lbl">ゲートパスワードのseed値</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="isTwoStepAuthValid" type="checkbox" class="ace" @click="ShowHideColumn" value="isTwoStepAuthValid" v-model="checkedColumnNames">
                      <span class="lbl">2段階認証の有効・無効</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="bleIntensity" type="checkbox" class="ace" @click="ShowHideColumn" value="bleIntensity" v-model="checkedColumnNames">
                      <span class="lbl">BLE出力設定</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="buzzerPattern" type="checkbox" class="ace" @click="ShowHideColumn" value="buzzerPattern" v-model="checkedColumnNames">
                      <span class="lbl">ブザー鳴動設定</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="option1" type="checkbox" class="ace" @click="ShowHideColumn" value="option1" v-model="checkedColumnNames">
                      <span class="lbl">備考.1</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="option2" type="checkbox" class="ace" @click="ShowHideColumn" value="option2" v-model="checkedColumnNames">
                      <span class="lbl">備考.2</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateSNMain" type="checkbox" class="ace" @click="ShowHideColumn" value="gateSNMain" v-model="checkedColumnNames">
                      <span class="lbl">ゲート個体番号1</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateSNBLE" type="checkbox" class="ace" @click="ShowHideColumn" value="gateSNBLE" v-model="checkedColumnNames">
                      <span class="lbl">ゲート個体番号2</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateFWMain" type="checkbox" class="ace" @click="ShowHideColumn" value="gateFWMain" v-model="checkedColumnNames">
                      <span class="lbl">適用されているファームウェアバージョン（メインボード）</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="gateFWBLE" type="checkbox" class="ace" @click="ShowHideColumn" value="gateFWBLE" v-model="checkedColumnNames">
                      <span class="lbl">適用されているファームウェアバージョン（BLE）</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="registered" type="checkbox" class="ace" @click="ShowHideColumn" value="registered" v-model="checkedColumnNames">
                      <span class="lbl">登録日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="updated" type="checkbox" class="ace" @click="ShowHideColumn" value="updated" v-model="checkedColumnNames">
                      <span class="lbl">更新日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="reported" type="checkbox" class="ace" @click="ShowHideColumn" value="reported" v-model="checkedColumnNames">
                      <span class="lbl">ゲートへ設定情報を適用した日時</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="revisionDesired" type="checkbox" class="ace" @click="ShowHideColumn" value="revisionDesired" v-model="checkedColumnNames">
                      <span class="lbl">個人コード照合データー：最新リビジョン</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="revisionReported" type="checkbox" class="ace" @click="ShowHideColumn" value="revisionReported" v-model="checkedColumnNames">
                      <span class="lbl">個人コード照合データー：ゲートへ設定済みのリビジョン</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="voltage" type="checkbox" class="ace" @click="ShowHideColumn" value="voltage" v-model="checkedColumnNames">
                      <span class="lbl">電池電圧</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="scanDate" type="checkbox" class="ace" @click="ShowHideColumn" value="scanDate" v-model="checkedColumnNames">
                      <span class="lbl">電池電圧更新日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="isValid" type="checkbox" class="ace" @click="ShowHideColumn" value="isValid" v-model="checkedColumnNames">
                      <span class="lbl">ステータス</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページごとに表示する項目数</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                  <div class="checkbox table_items">
                    <label>
                      <input type="checkbox" class="ace" checked v-model="notLoadAllDataGate" @click="reLoadData()">
                      <span class="lbl">有効なデーターのみ表示</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="gateId" class="gateId sorting" @click="sort('gateId', 'gateId')">ゲートID</th>
              <th id="gateModelId" class="gateModelId sorting center" @click="sort('gateModelId', 'gateModelId')" v-bind:class="{'none': checkColumnShowHide('gateModelId')}">製品ID</th>
              <th id="gateModelName" class="gateModelName sorting" @click="sort('gateModelName', 'gateModelName')" v-bind:class="{'none': checkColumnShowHide('gateModelName')}">製品名</th>
              <th id="gateModelCode" class="gateModelCode sorting center" @click="sort('gateModelCode', 'gateModelCode')" v-bind:class="{'none': checkColumnShowHide('gateModelCode')}">型番</th>
              <th id="iconType" class="iconType center" v-bind:class="{'none': checkColumnShowHide('iconType')}">アイコンタイプ</th>
              <th id="makerCode" class="makerCode sorting center" @click="sort('makerCode', 'makerCode')" v-bind:class="{'none': checkColumnShowHide('makerCode')}">メーカー番号</th>
              <th id="customizable" class="customizable sorting center" @click="sort('customizable', 'customizable')" v-bind:class="{'none': checkColumnShowHide('customizable')}">変更有無</th>
              <th id="target" class="target sorting center" @click="sort('target', 'target')" v-bind:class="{'none': checkColumnShowHide('target')}">ターゲット動作設定</th>
              <th id="controlTime" class="controlTime sorting center" @click="sort('controlTime', 'controlTime')" v-bind:class="{'none': checkColumnShowHide('controlTime')}">ターゲット動作設定Time</th>
              <th id="timeUnit" class="timeUnit sorting center" @click="sort('timeUnit', 'timeUnit')" v-bind:class="{'none': checkColumnShowHide('timeUnit')}">ターゲット動作設定TimeUnit</th>
              <th id="gateName" class="gateName sorting" @click="sort('gateName', 'gateName')" v-bind:class="{'none': checkColumnShowHide('gateName')}">ゲート名</th>
              <th id="isVisitor" class="isVisitor sorting center" @click="sort('isVisitor', 'isVisitor')" v-bind:class="{'none': checkColumnShowHide('isVisitor')}">ゲート動作モード</th>
              <th id="isNFCValid" class="isNFCValid sorting center" @click="sort('isNFCValid', 'isNFCValid')" v-bind:class="{'none': checkColumnShowHide('isNFCValid')}">NFCの有効</th>
              <th id="isTenKeyValid" class="isTenKeyValid sorting center" @click="sort('isTenKeyValid', 'isTenKeyValid')" v-bind:class="{'none': checkColumnShowHide('isTenKeyValid')}">テンキーの有効・無効</th>
              <th id="isGatePasswordValid" class="isGatePasswordValid sorting center" @click="sort('isGatePasswordValid', 'isGatePasswordValid')" v-bind:class="{'none': checkColumnShowHide('isGatePasswordValid')}">ゲートパスワードの有効・無効</th>
              <th id="gatePasswordLength" class="gatePasswordLength sorting center" @click="sort('gatePasswordLength', 'gatePasswordLength')" v-bind:class="{'none': checkColumnShowHide('gatePasswordLength')}">ゲートパスワードの桁数</th>
              <th id="gatePasswordSeed" class="gatePasswordSeed sorting center" @click="sort('gatePasswordSeed', 'gatePasswordSeed')" v-bind:class="{'none': checkColumnShowHide('gatePasswordSeed')}">ゲートパスワードのseed値</th>
              <th id="isTwoStepAuthValid" class="isTwoStepAuthValid sorting center" @click="sort('isTwoStepAuthValid', 'isTwoStepAuthValid')" v-bind:class="{'none': checkColumnShowHide('isTwoStepAuthValid')}">2段階認証の有効・無効</th>
              <th id="bleIntensity" class="bleIntensity sorting center" @click="sort('bleIntensity', 'bleIntensity')" v-bind:class="{'none': checkColumnShowHide('bleIntensity')}">BLE出力設定</th>
              <th id="buzzerPattern" class="buzzerPattern sorting center" @click="sort('buzzerPattern', 'buzzerPattern')" v-bind:class="{'none': checkColumnShowHide('buzzerPattern')}">ブザー鳴動設定</th>
              <th id="option1" class="option1 sorting center" @click="sort('option1', 'option1')" v-bind:class="{'none': checkColumnShowHide('option1')}">備考.1</th>
              <th id="option2" class="option2 sorting center" @click="sort('option2', 'option2')" v-bind:class="{'none': checkColumnShowHide('option2')}">備考.2</th>
              <th id="gateSNMain" class="gateSNMain sorting center" @click="sort('gateSNMain', 'gateSNMain')" v-bind:class="{'none': checkColumnShowHide('gateSNMain')}">ゲート個体番号1</th>
              <th id="gateSNBLE" class="gateSNBLE sorting center" @click="sort('gateSNBLE', 'gateSNBLE')" v-bind:class="{'none': checkColumnShowHide('gateSNBLE')}">ゲート個体番号2</th>
              <th id="gateFWMain" class="gateFWMain sorting center" @click="sort('gateFWMain', 'gateFWMain')" v-bind:class="{'none': checkColumnShowHide('gateFWMain')}">ファームウェアバージョン</th>
              <th id="gateFWBLE" class="gateFWBLE sorting center" @click="sort('gateFWBLE', 'gateFWBLE')" v-bind:class="{'none': checkColumnShowHide('gateFWBLE')}">ファームウェアバージョン（BLE）</th>
              <th id="registered" class="registered sorting center" @click="sort('registered', 'registered')" style="width:100px" v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
              <th id="updated" class="center updated sorting center" @click="sort('updated', 'updated')" style="width:100px" v-bind:class="{'none': checkColumnShowHide('updated')}">更新日</th>
              <th id="reported" class="reported center" v-bind:class="{'none': checkColumnShowHide('reported')}">ゲートへ設定情報を適用した日時</th>
              <th id="revisionDesired" class="revisionDesired sorting center" @click="sort('revisionDesired', 'revisionDesired')" v-bind:class="{'none': checkColumnShowHide('revisionDesired')}">個人コード照合データー：最新リビジョン</th>
              <th id="revisionReported" class="revisionReported sorting" @click="sort('revisionReported', 'revisionReported')" v-bind:class="{'none': checkColumnShowHide('revisionReported')}">個人コード照合データー：ゲートへ設定済みのリビジョン</th>
              <th id="voltage" class="voltage sorting center" @click="sort('voltage', 'voltage')" v-bind:class="{'none': checkColumnShowHide('voltage')}">電池電圧</th>
              <th id="scanDate" class="scanDate sorting center" @click="sort('scanDate', 'scanDate')" v-bind:class="{'none': checkColumnShowHide('scanDate')}">電池電圧更新日</th>
              <th id="isValid" class="center isValid sorting center" @click="sort('isValid', 'isValid')" style="width:100px" v-bind:class="{'none': checkColumnShowHide('isValid')}">ステータス</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr v-bind:class="{'selected': rowSelected(item.gateId)}" :id="item.gateId">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.gateId" v-model="selectedGateId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="gateId" @click="showdetail">{{item.gateId}}</td>
              <td class="gateModelId" v-bind:class="{'none': checkColumnShowHide('gateModelId')}" @click="showdetail">{{item.gateModelId}}</td>
              <td class="gateModelName" v-bind:class="{'none': checkColumnShowHide('gateModelName')}" @click="showdetail">{{item.gateModelName}}</td>
              <td class="gateModelCode" v-bind:class="{'none': checkColumnShowHide('gateModelCode')}" @click="showdetail">{{item.gateModelCode}}</td>
              <td class="iconType center" v-bind:class="{'none': checkColumnShowHide('iconType')}" @click="showdetail">{{item.iconType}}</td>
              <td class="makerCode center" v-bind:class="{'none': checkColumnShowHide('makerCode')}" @click="showdetail">{{item.makerCode}}</td>
              <td class="customizable center" v-bind:class="{'none': checkColumnShowHide('customizable')}" @click="showdetail">{{item.customizable}}</td>
              <td class="target center" v-bind:class="{'none': checkColumnShowHide('target')}" @click="showdetail">{{item.target}}</td>
              <td class="controlTime center" v-bind:class="{'none': checkColumnShowHide('controlTime')}" @click="showdetail">{{item.controlTime}}</td>
              <td class="timeUnit center" v-bind:class="{'none': checkColumnShowHide('timeUnit')}" @click="showdetail">{{item.timeUnit}}</td>
              <td class="gateName" v-bind:class="{'none': checkColumnShowHide('gateName')}" @click="showdetail">{{item.gateName}}</td>
              <td class="isVisitor center" v-bind:class="{'none': checkColumnShowHide('isVisitor')}" @click="showdetail"><span v-if="item.isVisitor">有効</span><span v-else >無効</span></td>
              <td class="isNFCValid center" v-bind:class="{'none': checkColumnShowHide('isNFCValid')}" @click="showdetail"><span v-if="item.isNFCValid">有効</span><span v-else >無効</span></td>
              <td class="isTenKeyValid center" v-bind:class="{'none': checkColumnShowHide('isTenKeyValid')}" @click="showdetail"><span v-if="item.isTenKeyValid">有効</span><span v-else >無効</span></td>
              <td class="isGatePasswordValid center" v-bind:class="{'none': checkColumnShowHide('isGatePasswordValid')}" @click="showdetail"><span v-if="item.isGatePasswordValid">有効</span><span v-else >無効</span></td>
              <td class="gatePasswordLength center" v-bind:class="{'none': checkColumnShowHide('gatePasswordLength')}" @click="showdetail">{{item.gatePasswordLength}}</td>
              <td class="gatePasswordSeed center" v-bind:class="{'none': checkColumnShowHide('gatePasswordSeed')}" @click="showdetail">{{item.gatePasswordSeed}}</td>
              <td class="isTwoStepAuthValid " v-bind:class="{'none': checkColumnShowHide('isTwoStepAuthValid')}" @click="showdetail"><span v-if="item.isTwoStepAuthValid">有効</span><span v-else >無効</span></td>
              <td class="bleIntensity center" v-bind:class="{'none': checkColumnShowHide('bleIntensity')}" @click="showdetail">{{item.bleIntensity}}</td>
              <td class="buzzerPattern center" v-bind:class="{'none': checkColumnShowHide('buzzerPattern')}" @click="showdetail">{{item.buzzerPattern}}</td>
              <td class="option1" v-bind:class="{'none': checkColumnShowHide('option1')}" @click="showdetail">{{item.option1}}</td>
              <td class="option2" v-bind:class="{'none': checkColumnShowHide('option2')}" @click="showdetail">{{item.option2}}</td>
              <td class="gateSNMain center" v-bind:class="{'none': checkColumnShowHide('gateSNMain')}" @click="showdetail">{{item.gateSNMain}}</td>
              <td class="gateSNBLE center" v-bind:class="{'none': checkColumnShowHide('gateSNBLE')}" @click="showdetail">{{item.gateSNBLE}}</td>
              <td class="gateFWMain center" v-bind:class="{'none': checkColumnShowHide('gateFWMain')}" @click="showdetail">{{item.gateFWMain}}</td>
              <td class="gateFWBLE center" v-bind:class="{'none': checkColumnShowHide('gateFWBLE')}" @click="showdetail">{{item.gateFWBLE}}</td>
              <td class="registered center" v-bind:class="{'none': checkColumnShowHide('registered')}" @click="showdetail">{{ converDate(item.registered) }}</td>
              <td class="updated center" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('updated')}">{{ converDate(item.updated) }}</td>
              <td class="reported center" v-bind:class="{'none': checkColumnShowHide('reported')}" @click="showdetail">{{item.reported}}</td>
              <td class="revisionDesired center" v-bind:class="{'none': checkColumnShowHide('revisionDesired')}" @click="showdetail">{{item.revisionDesired}}</td>
              <td class="revisionReported center" v-bind:class="{'none': checkColumnShowHide('revisionReported')}" @click="showdetail">{{item.revisionReported}}</td>
              <td class="voltage center" v-bind:class="{'none': checkColumnShowHide('voltage')}" @click="showdetail">{{item.voltage}}</td>
              <td class="scanDate center" v-bind:class="{'none': checkColumnShowHide('scanDate')}" @click="showdetail">{{converDate(item.scanDate)}}</td>
              <td class="isValid center" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('isValid')}"><span v-if="item.isValid">有効</span><span v-else >無効</span></td>
            </tr>
            <tr class="detail-row">
              <td v-bind:colspan ="columnCount">
                <div class="table-detail detail-gate">
                  <div class="row">
                    <div class="col-xs-12 col-sm-2">
                      <div class="text-center">
                        <button class="btn btn-info edit-bottom" type="button" @click="handleEdit(item.gateId)">編集</button>
                        <button class="btn edit-bottom black-btn" type="button" href="#generatePassword" data-toggle="modal" @click="setGateId(item.gateId)" :disabled="!item.isGatePasswordValid || !item.isValid">ゲートパスワード取得</button>
                      </div>
                    </div>
                    <div class="col-sm-10">
                      <div id="accordion" class="accordion-style1 panel-group">
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" v-bind:href="randomAcountHref(item.gateId)">
                                <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                                &nbsp;ゲート詳細
                              </a>
                            </h4>
                          </div>
                          <div class="panel-collapse collapse" :id="randomAcountClass(item.gateId)">
                            <div class="panel-body">
                              <div class="col-xs-6">
                                <div class="row">
                                <div class="profile-user-info profile-user-info-striped">
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲートID</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateId}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">製品ID</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateModelId}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">製品名</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateModelName}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">型番</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateModelCode}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">アイコンタイプ</div>
                                    <div class="profile-info-value">
                                      <select class="form-control" v-model="item.iconType" disabled>
                                        <option v-for="item in listIconType" v-bind:value="item.value" v-bind:key="item.value">
                                          {{item.text}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <!--<div class="profile-info-row">
                                    <div class="profile-info-name">メーカー番号</div>
                                    <div class="profile-info-value">
                                      <span>{{item.makerCode}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">変更有無</div>
                                    <div class="profile-info-value">
                                      <span>{{item.customizable}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ターゲット動作設定</div>
                                    <div class="profile-info-value">
                                      <span>{{item.target}}</span>
                                    </div>
                                  </div>-->
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ターゲット動作設定Time</div>
                                    <div class="profile-info-value">
                                      <span>{{item.controlTime}}</span>
                                    </div>
                                  </div>
                                  <!--<div class="profile-info-row">
                                    <div class="profile-info-name">ターゲット動作設定TimeUnit</div>
                                    <div class="profile-info-value">
                                      <span>{{item.timeUnit}}</span>
                                    </div>
                                  </div>-->
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲート名</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateName}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲート動作モード</div>
                                    <div class="profile-info-value">
                                      <select class="form-control" v-model="item.isVisitor" disabled>
                                        <option v-for="item in listIsVisitor" v-bind:value="item.value" v-bind:key="item.value">
                                          {{item.text}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">NFCの有効</div>
                                    <div class="profile-info-value">
                                      <span v-if="item.isNFCValid">有効</span><span v-else >無効</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">テンキーの有効・無効</div>
                                    <div class="profile-info-value">
                                      <span v-if="item.isTenKeyValid">有効</span><span v-else >無効</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲートパスワードの有効・無効</div>
                                    <div class="profile-info-value">
                                      <span v-if="item.isGatePasswordValid">有効</span><span v-else >無効</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲートパスワードの桁数</div>
                                    <div class="profile-info-value">
                                      <select class="form-control" v-model="item.gatePasswordLength" disabled>
                                        <option v-for="item in listPassLenght" v-bind:value="item.value" v-bind:key="item.value">
                                          {{item.text}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲートパスワードのseed値</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gatePasswordSeed}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">2段階認証の有効・無効</div>
                                    <div class="profile-info-value">
                                      <span v-if="item.isTwoStepAuthValid">有効</span><span v-else >無効</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">BLE出力設定</div>
                                    <div class="profile-info-value">
                                      <select class="form-control" v-model="item.bleIntensity" disabled>
                                        <option v-for="item in listBleIntensity" v-bind:value="item.value" v-bind:key="item.value">
                                          {{item.text}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ブザー鳴動設定</div>
                                    <div class="profile-info-value">
                                      <select class="form-control" v-model="item.buzzerPattern" disabled>
                                        <option v-for="item in listBuzzerPattern" v-bind:value="item.value" v-bind:key="item.value">
                                          {{item.text}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                </div>
                              </div>
                              <div class="col-xs-6">
                                <div class="row">
                                <div class="profile-user-info profile-user-info-striped">
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">備考.1</div>
                                    <div class="profile-info-value">
                                      <span>{{item.option1}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">備考.2</div>
                                    <div class="profile-info-value">
                                      <span>{{item.option2}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲート個体番号1</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateSNMain}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲート個体番号2</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateSNBLE}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">適用されているファームウェアバージョン（メインボード）</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateFWMain}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">適用されているファームウェアバージョン（BLE）</div>
                                    <div class="profile-info-value">
                                      <span>{{item.gateFWBLE}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">登録日</div>
                                    <div class="profile-info-value">
                                      <span>{{converDate(item.registered)}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">更新日</div>
                                    <div class="profile-info-value">
                                      <span>{{converDate(item.updated)}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ゲートへ設定情報を適用した日時</div>
                                    <div class="profile-info-value">
                                      <span>{{converDate(item.reported)}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">個人コード照合データー：最新リビジョン</div>
                                    <div class="profile-info-value">
                                      <span>{{item.revisionDesired}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">個人コード照合データー：ゲートへ設定済みのリビジョン</div>
                                    <div class="profile-info-value">
                                      <span>{{item.revisionReported}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">電池電圧</div>
                                    <div class="profile-info-value">
                                      <span>{{item.voltage}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">電池電圧更新日</div>
                                    <div class="profile-info-value">
                                      <span>{{converDate(item.scanDate)}}</span>
                                    </div>
                                  </div>
                                  <div class="profile-info-row">
                                    <div class="profile-info-name">ステータス</div>
                                    <div class="profile-info-value">
                                      <span><span v-if="item.isValid">有効</span><span v-else >無効</span></span>
                                    </div>
                                  </div>
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" v-bind:href="randomDeviceHref(item.gateId)" aria-expanded="true">
                                <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                                &nbsp;ゲートグループ
                              </a>
                            </h4>
                          </div>
                          <div class="panel-collapse collapse" :id="randomDeviceClass(item.gateId)">
                            <div class="panel-body">
                              <table style="min-width:100%" class="table table-striped table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th>ゲートグループID</th>
                                    <th>ゲートグループ名</th>
                                    <th class="center">ステータス</th>
                                  </tr>
                                </thead>
                                <tbody v-if="listGateGroup[item.gateId]!=null">
                                  <template v-for="(item, index) in listGateGroup[item.gateId]">
                                    <tr :key="index">
                                      <td><a class="link" @click="viewGroup(item.groupId.groupId)">{{item.groupId.groupId}}</a></td>
                                      <td>{{item.groupId.name}}</td>
                                      <td class="center"><span v-if="item.groupId.isValid">有効</span><span v-else >無効</span></td>
                                    </tr>
                                  </template>
                                </tbody>
                                <tbody v-else>
                                  <tr>
                                    <td colspan="3">データーはありません</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a class="accordion-toggle collapsed" data-toggle="collapse" v-bind:href="randomGateHref(item.gateId)">
                                <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                                &nbsp;期限付きゲートを持つユーザー
                              </a>
                            </h4>
                          </div>
                          <div class="panel-collapse collapse" :id="randomGateClass(item.gateId)" aria-expanded="true">
                            <div class="panel-body">
                              <table style="min-width:100%" class="table table-striped table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th>ユーザーID</th>
                                    <th>ユーザー名</th>
                                    <th>ふりがな</th>
                                    <th class="center">ステータス</th>
                                    <th class="center">開始日時</th>
                                   <th class="center">終了日時</th>
                                  </tr>
                                </thead>
                                <tbody v-if="listGatePassages[item.gateId]!=null">
                                  <template v-for="(item, index) in listGatePassages[item.gateId]">
                                    <tr :key="index">
                                      <td><a class="link" @click="viewUser(item.userId.userId)">{{item.userId.userId}}</a></td>
                                      <td>{{item.userId.name}}</td>
                                      <td>{{item.userId.furigana}}</td>
                                      <td class="center"><span v-if="item.userId.isValid">有効</span><span v-else >無効</span></td>
                                      <td class="center">{{converDateLong(item.notBefore)}}</td>
                                      <td class="center">{{converDateLong(item.notAfter)}}</td>
                                    </tr>
                                  </template>
                                </tbody>
                                <tbody v-else>
                                  <tr>
                                    <td colspan="6">データーはありません</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>ゲートID</th>
              <th>製品名</th>
              <th>ゲート名</th>
              <th>ステータス</th>
              <th>更新日</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="6">{{message}}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">ゲートを無効化</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックしたゲートを一括無効化します、よろしいですか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successGate>0">{{countGate}}件中{{successGate}}件を無効化しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">無効化失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="updateAllStatus()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <!-- ゲートパスワード取得 -->
  <div id="generatePassword" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin center">ゲートパスワードの取得</h3>
        </div>
        <div class="modal-body">
          <div class="profile-user-info profile-user-info-striped">
            <div class="profile-info-row">
              <div class="profile-info-name" style="width:200px;text-align:left">対象のゲート（ゲートID）</div>
              <div class="profile-info-value">
                <span>{{gateId}}</span>
              </div>
            </div>
            <div class="profile-info-row">
              <div class="profile-info-name" style="width:200px;text-align:left">ゲートを利用する日付</div>
              <div class="profile-info-value">
                <div class="input-group">
                  <input class="form-control" name="sdate" type="text" data-date-format="yyyy-mm-dd" style="text-align:left" />
                  <span class="input-group-addon icon_date">
                    <i class="fa fa-calendar bigger-110"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="profile-info-row">
              <div class="profile-info-name" style="width:200px;text-align:left">ゲートを利用する時間</div>
              <div class="profile-info-value">
                <select class="form-control" v-model="scorpId">
                  <option v-for="item in listTime" v-bind:value="item.value" v-bind:key="item.value">
                    {{item.text}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div>
            <span style="border: 1px solid #DCEBF7;border-top:0px solid #ccc;display: block;margin: 0px auto;width: calc(100% - 24px);font-size:20px;text-align:center;padding: 5px;min-height: 35px;">{{password}}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger pull-right" style="width:200px" @click="passwordGenerate()">パスワードを発行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <a href="javascript:void(0)" class="float" id="menu-share">
    <i class="fa fa-plus my-float"></i>
  </a>
  <ul class="add_btn_list">
    <li>
      <router-link :to="{ name: 'gateadd'}" class="adduser">
        <i class="menu-icon glyphicon glyphicon-log-in my-float"></i>
      </router-link>
      <div class="label-container">
        <div class="label-text">新規ゲート登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
    <li>
      <router-link :to="{ name: 'gateimport'}" class="adduserExport">
        <i class="ace-icon glyphicon glyphicon-upload my-float"></i>
      </router-link>
      <div class="label-container-export">
        <div class="label-text">CSVインポートでゲート登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
  </ul>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      currentTime: '',
      errorMessageLogs: '',
      message: 'データー取得中',
      listGatePassages: {},
      list: null,
      gateId: '',
      date: '2018-09-25',
      scorpId: 1,
      password: '',
      listGateGroup: {},
      scorp: ['gateId', 'gateModelName', 'gateName', 'option1', 'option2'],
      groupId: '',
      selected: 100,
      total: 0,
      pages: 0,
      error: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listTime: [
        { text: '00:00〜23:59', value: 1 },
        { text: '00:00〜11:59', value: 2 },
        { text: '12:00〜23:59', value: 3 },
        { text: '09:00〜16:59', value: 4 }
      ],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      listIconType: [
        { text: 'ドア', value: 1 },
        { text: 'ロッカー', value: 2 },
        { text: 'その他', value: 0 }

      ],
      listControlTime: [
        { text: '0000－9999 S', value: 0 },
        { text: '000.0-999.9 S', value: 1 },
        { text: '00.00-99.99 S', value: 2 },
        { text: '0.000-9.999 S', value: 3 }
      ],
      listIsVisitor: [
        { text: 'ビジター', value: true },
        { text: 'メンバー', value: false }
      ],
      listBuzzerPattern: [
        { text: 'OFF', value: 0 },
        { text: '鳴動パターン１', value: 1 },
        { text: '鳴動パターン２', value: 2 }
      ],
      listPassLenght: [
        { text: '5桁', value: 5 },
        { text: '6桁', value: 6 },
        { text: '7桁', value: 7 },
        { text: '8桁', value: 8 }
      ],
      listBleIntensity: [
        { text: '4dBm', value: 0 },
        { text: '0dBm', value: 1 },
        { text: '-4dBm', value: 2 },
        { text: '-8dBm', value: 3 },
        { text: '-12dBm', value: 4 },
        { text: '-16dBm', value: 5 },
        { text: '-20dBm', value: 6 },
        { text: '-40dBm', value: 7 }
      ],
      columnNames: [
        'gateModelCode',
        'gateModelName',
        'gateModelId',
        'iconType',
        'makerCode',
        'customizable',
        'target',
        'controlTime',
        'timeUnit',
        'gateName',
        'isVisitor',
        'isNFCValid',
        'isTenKeyValid',
        'isGatePasswordValid',
        'gatePasswordLength',
        'gatePasswordSeed',
        'isTwoStepAuthValid',
        'bleIntensity',
        'buzzerPattern',
        'option1',
        'option2',
        'gateSNMain',
        'gateSNBLE',
        'gateFWMain',
        'gateFWBLE',
        'registered',
        'updated',
        'reported',
        'revisionDesired',
        'revisionReported',
        'voltage',
        'scanDate',
        'isValid'
      ],
      checkedColumnNames: [
        'gateModelName',
        'gateName',
        'updated',
        'isValid'
      ],
      notLoadAllDataGate: true,
      columnCount: 0,
      progress: 0,
      selectedGateId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successGate: 0,
      errorName: '',
      exeCount: 0,
      percent: 0,
      countGate: 0
    }
  },
  watch: {
    'progress': 'checkProgress',
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countGate) {
        vm.updateStatus(this.selectedGateId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countGate) {
        this.exeCount = 0
        this.getList()
      }
    }
  },
  created () {
    if (typeof localStorage.notLoadAllDataGate === 'undefined') {
      localStorage.setItem('notLoadAllDataGate', 'yes')
    }
    if (typeof localStorage.pageSizeListGate === 'undefined') {
      localStorage.setItem('pageSizeListGate', 100)
      this.selected = localStorage.pageSizeListGate
    } else {
      this.selected = localStorage.pageSizeListGate
    }
    if (typeof localStorage.groupGateListSortKey === 'undefined') {
      localStorage.setItem('groupGateListSortKey', 'registered')
    }
    if (typeof localStorage.groupGateListSortName === 'undefined') {
      localStorage.setItem('groupGateListSortName', 'desc')
    }
    if (typeof localStorage.checkedGate === 'undefined') {
      localStorage.setItem('checkedGate', this.checkedColumnNames)
    } else {
      var tempData = []
      this.columnNames.forEach(function (item) {
        if (localStorage.checkedGate.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
  },
  mounted () {
    var vm = this
    var count = $('.view-option input[type=checkbox]:checked').length
    var not = $('.view-option input[type=checkbox]').not(':checked')
    if (count >= 8) {
      not.attr('disabled', true)
    }
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    $('input[name=sdate]').attr('autocomplete', 'off')
    $('input[name=sdate]').datepicker({
      language: 'ja',
      format: 'yyyy-mm-dd',
      autoclose: true,
      todayHighlight: true
    })
    $('input[name=sdate]').datepicker().datepicker('setDate', new Date())
    $('.icon_date').click(function () {
      $('input[name=sdate]').focus()
    })
    if (localStorage.notLoadAllDataGate === 'yes') {
      this.notLoadAllDataGate = true
    } else {
      this.notLoadAllDataGate = false
    }
    this.columnCount = this.checkedColumnNames.length + 2
    vm.currentTime = vm.converTimestamp(Date())
    this.getList()
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        return this.list ? this.selectedGateId.length >= this.list.length : false
      },
      set: function (value) {
        var selectedGateId = []
        if (value) {
          this.list.forEach(function (item) {
            selectedGateId.push(item.gateId)
          })
        }
        this.selectedGateId = selectedGateId
      }
    }
  },
  methods: {
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    resetView () {
      $('#simple-table').find('tr.detail-row').removeClass('open')
      $('div.panel-collapse').removeClass('in')
      $('a.accordion-toggle').addClass('collapsed')
      $('a.accordion-toggle i').addClass('fa-angle-right')
      $('a.accordion-toggle i').removeClass('fa-angle-down')
    },
    reLoadData () {
      if (localStorage.notLoadAllDataGate === 'yes') {
        localStorage.setItem('notLoadAllDataGate', 'no')
      } else {
        localStorage.setItem('notLoadAllDataGate', 'yes')
      }
      this.pages = 0
      this.listQuery.currPage = 1
      this.getList()
    },
    updateChecked () {
      localStorage.setItem('checkedGate', this.checkedColumnNames)
      this.columnCount = this.checkedColumnNames.length + 2
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedGate.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    viewUser (id) {
      let routeData = this.$router.resolve({name: 'useredit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    viewGroup (id) {
      let routeData = this.$router.resolve({name: 'groupedit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    setGateId (gateId) {
      this.gateId = gateId
      this.password = ''
      this.scorpId = 1
      $('input[name=sdate]').datepicker().datepicker('setDate', new Date())
    },
    passwordGenerate () {
      var vm = this
      vm.loading = true
      vm.date = $('input[name=sdate]').val()
      this.$http.get(Config.GATES_LIST_API + '/' + encodeURIComponent(vm.gateId) + '/password?date=' + vm.date + '&scorpId=' + vm.scorpId)
        .then(response => {
          console.log(response)
          vm.password = response.body.gatePassword
          vm.loading = false
        })
        .catch(error => {
          switch (error.status) {
            case 400:
              vm.password = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.password = 'ゲートパスワードの取得権限がありません。'
              break
            case 404:
              vm.password = '該当するデーターがありません。'
              break
            case 500:
              vm.password = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.password = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          console.log(error)
          vm.loading = false
        })
    },
    // チェックしたゲートを無効化
    updateStatus (gateId, percent, i) {
      var vm = this
      this.$http.put(Config.GATES_LIST_API + '/' + encodeURIComponent(gateId), {isValid: false})
        .then(response => {
          vm.progress += percent
          vm.successGate++
          vm.exeCount++
        })
        .catch((error) => {
          this.progress += percent
          vm.exeCount++
          switch (error.status) {
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'ゲートの編集権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              this.errorName = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = gateId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
        })
    },
    updateAllStatus () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedGateId.length > 0) {
        this.countGate = this.selectedGateId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedGateId.length)
        vm.updateStatus(this.selectedGateId[0], vm.percent, 0)
      } else {
        alert('少なくてもゲートを１つ選んでください。')
      }
    },
    getInforUser (gateId, userId, i) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          vm.listGatePassages[gateId][i].userId = response.body.users[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInforGatePassage (gateId) {
      var vm = this
      this.$http.get(Config.GATES_PASSAGE_API + '?gateId=' + encodeURIComponent(gateId) + '&notBefore=' + vm.currentTime)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.$set(vm.listGatePassages, gateId, response.body.passages)
            for (var i = 0; i < vm.listGatePassages[gateId].length; i++) {
              vm.getInforUser(vm.listGatePassages[gateId][i].gateId, vm.listGatePassages[gateId][i].userId, i)
            }
          } else {
            vm.listGatePassages[gateId] = null
          }
        })
        .catch((error) => {
          console.log(error)
          vm.listGatePassages[gateId] = null
        })
    },
    getGroupInfo (groupId, gateId, i) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          vm.listGateGroup[gateId][i].groupId = response.body.groups[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInforGateGroup (gateId) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?gateId=' + encodeURIComponent(gateId))
        .then(response => {
          this.$set(vm.listGateGroup, gateId, response.body.relationsGateGroup)
          if (vm.listGateGroup[gateId].length > 0) {
            for (var i = 0; i < vm.listGateGroup[gateId].length; i++) {
              vm.getGroupInfo(vm.listGateGroup[gateId][i].groupId, vm.listGateGroup[gateId][i].gateId, i)
            }
          } else {
            vm.listGateGroup[gateId] = null
          }
        })
        .catch((error) => {
          vm.listGateGroup[gateId] = null
          console.log(error)
        })
    },
    randomAcountClass (classname) {
      var data = classname.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '')
      return 'acount' + data
    },
    randomAcountHref (classname) {
      var data = classname.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '')
      return '#acount' + data
    },
    randomDeviceClass (classname) {
      var data = classname.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '')
      return 'device' + data
    },
    randomDeviceHref (classname) {
      var data = classname.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '')
      return '#device' + data
    },
    randomGateClass (classname) {
      var data = classname.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '')
      return 'gate' + data
    },
    randomGateHref (classname) {
      var data = classname.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '')
      return '#gate' + data
    },
    // スマートフォン詳細を開く
    showdetail: function (e) {
      e.preventDefault()
      $(e.target).closest('tr').next().toggleClass('open')
      var gateId = $(e.target).closest('tr').attr('id')
      if (typeof this.listGatePassages[gateId] === 'undefined') {
        this.getInforGatePassage(gateId)
      }
      if (typeof this.listGatePassages[gateId] === 'undefined') {
        this.getInforGateGroup(gateId)
      }
    },
    converDateLong (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD H:mm')
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    },
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedGateId = []
      }
    },
    // チェックしたスマートフォンを無効化すり前にリセット
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックしたゲートを一括無効化します、よろしいですか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successGate = 0
      this.countGate = 0
      this.exeCount = 0
    },
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedGateId) !== -1) {
        return true
      } else {
        return false
      }
    },
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    search () {
      var apiLink = ''
      this.errorMessageLogs = ''
      this.loading = true
      if (this.scorp.length > 0) {
        this.resetView()
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        if (localStorage.notLoadAllDataGate === 'yes') {
          apiLink = Config.GATES_LIST_API + '?limit=' + localStorage.pageSizeListGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.groupGateListSortName + ':' + localStorage.groupGateListSortKey + '&isValid=true'
        } else {
          apiLink = Config.GATES_LIST_API + '?limit=' + localStorage.pageSizeListGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.groupGateListSortName + ':' + localStorage.groupGateListSortKey
        }
        this.$http.get(apiLink)
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.loading = false
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeListGate)
              this.list = response.body.gates
              console.log(response)
            } else {
              this.loading = false
              this.list = null
              this.pages = 0
              this.message = '該当するデーターがありません。'
            }
          })
          .catch((error) => {
            this.list = null
            this.loading = false
            this.pages = 0
            this.message = '該当するデーターがありません。'
            switch (error.status) {
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'ゲートの取得権限がありません。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('groupGateListSortName', 'desc')
        localStorage.setItem('groupGateListSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('groupGateListSortName', 'asc')
        localStorage.setItem('groupGateListSortKey', sortkey)
      }
      this.getList()
    },
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeListGate', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    handleCurrentChange (val) {
      this.selectedGateId = []
      this.listQuery.currPage = val
      this.getList()
      $('#simple-table').find('tr.detail-row').removeClass('open')
      window.scrollTo(0, 0)
    },
    ShowHideColumn: function (e) {
      var count = $('.view-option input[type=checkbox]:checked').length
      var not = $('.view-option input[type=checkbox]').not(':checked')
      if (count >= 8) {
        not.attr('disabled', true)
      } else {
        not.attr('disabled', false)
      }
      if (count <= 8) {
        var $tbl = $('#simple-table')
        var colToHide = $tbl.find('.' + $(e.target).attr('name'))
        $(colToHide).toggle()
      }
    },
    handleEdit (id) {
      this.$router.push({name: 'gateedit', query: { id: id }})
    },
    getList () {
      var apiLink = ''
      this.errorMessageLogs = ''
      this.loading = true
      this.resetView()
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      if (localStorage.notLoadAllDataGate === 'yes') {
        apiLink = Config.GATES_LIST_API + '?limit=' + localStorage.pageSizeListGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.groupGateListSortName + ':' + localStorage.groupGateListSortKey + '&isValid=true'
      } else {
        apiLink = Config.GATES_LIST_API + '?limit=' + localStorage.pageSizeListGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.groupGateListSortName + ':' + localStorage.groupGateListSortKey
      }
      this.$http.get(apiLink)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeListGate)
            this.list = response.body.gates
            console.log(response)
          } else {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
          }
        })
        .catch(error => {
          this.loading = false
          this.list = null
          this.pages = 0
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'ゲートの取得権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 5px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.detail-gate .profile-info-name{
  width: 250px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.warring2 {
    display: block;
    padding: 8px 5px;
    font-size: 14px;
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/gate/GateList.vue